//import components
import Breadcrumb from './../components/dynamic/Breadcrumb';
import Form from '../components/dynamic/contact/Form';
import Address from '../components/dynamic/contact/Address';
import Phone from '../components/dynamic/contact/Phone';
import Email from '../components/dynamic/contact/Email';

//import locales
import { useTranslation } from "react-i18next";
import "../i18n";

export default function Contact() {

    //get locale
    const { t } = useTranslation();

    return (
        <>
            <Breadcrumb title={t('contact')} />
            <div className='container mx-auto mt-12 px-3'>
                <div className='grid grid-cols-12 gap-5'>
                    <div className='col-span-12 md:col-span-7'>
                        <Form />
                    </div>
                    <div className='col-span-12 md:col-span-5 px-0 mt-4 md:mt-0 md:px-7'>
                        <h4 className='font-bold upper text-[30px] mb-5'>{t('contact_info')}</h4>
                        <p className='mb-10'>{t('contact_text')}</p>
                        <Address className="mb-4 flex" />
                        <Phone className="mb-4 flex" />
                        <Email className="mb-4 flex" />

                        <iframe className='mt-10' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2977.7211040542725!2d44.72754927667794!3d41.726536671258835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4044735ad15f0975%3A0xaff8871aeb98b40d!2swww.Planetarium.ge!5e0!3m2!1ska!2sge!4v1700728772891!5m2!1ska!2sge" width="100%" height="400" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

                    </div>
                </div>
            </div>
        </>
    );
}